import { LOVE_TEMPLATES } from '@Web/Pages/Web/Templates/constants';
import SectionHeader from '@Web/Src/Components/SectionHeader';
import Card from '@Web/Pages/Web/Templates/Components/Card';
import Button from '@Web/Src/Components/Button';
import { router } from '@inertiajs/react';

function TemplatesWeLove() {
    const handleLogin = () => [router.visit(route('customer.auth.login'))];

    return (
        <div className='flex w-full flex-col items-center'>
            <SectionHeader
                className='mx-auto mt-24'
                icon='hearts'
                title={__('Referral Program Templates That We Love')}
                desc={__(
                    'Our team has created a library of templates you can easily copy and use for your customer referral program. With these templates, you can set up your program in minutes—no coding or prior experience needed. '
                )}
            />
            <div className='mx-auto mt-20 flex w-full max-w-[1200px] flex-wrap justify-center gap-4'>
                {LOVE_TEMPLATES.map((item, index) => {
                    return <Card key={index} item={item} />;
                })}
            </div>
            <p className='medium:text-base mt-20 text-xl'>
                {__('Log in to access hundreds more referral program templates!')}
            </p>
            <Button
                onClick={handleLogin}
                className='mt-10'
                name={__('Log in to Referral Factory')}
            />
        </div>
    );
}

export default TemplatesWeLove;
